export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7005.cfc371b4.jpg";